import angular from 'angular';

angular
  .module('cxSettings')
  .controller('AddTaskPeriodicityDialogCtrl', [
    '$element',
    '$scope',
    '$http',
    'appUrls',
    'flySvc',
    'enumCacheSvc',
    'translateListFilter',
    'close',
    'taskTemplateId',
    addTaskPeriodicityDialogCtrl,
  ]);

function addTaskPeriodicityDialogCtrl(
  $element,
  $scope,
  $http,
  appUrls,
  flySvc,
  enumCacheSvc,
  translateListFilter,
  close,
  taskTemplateId,
) {
  var vm = this;
  vm.showValidation = false;
  vm.translation = {};
  vm.period = null;
  vm.currentYear = new Date().getFullYear();
  vm.nextYear = vm.currentYear + 1;
  vm.deadlineDeviation = 0;
  vm.deadlineDeviationFactor = -1;
  vm.schedule = {
    name: '',
    planningDeviation: 0,
    referenceYearType: null,
  };
  vm.dayOfWeek = [];
  vm.numberOfWeeks = null;
  vm.updateName = function(value) {
    vm.schedule.name = value;
  };
  vm.dayMonthOptions = {
    minMode: 'day',
    maxMode: 'month',
    showWeeks: false,
    formatDayTitle: 'MMMM',
    datepickerMode: 'month',
    formatMonthTitle: ' ',
    initDate: new Date(2000, 11, 31),
    // minDate: new Date(2000, 0, 1),
    // maxDate: new Date(2000, 11, 31),
  };
  vm.dayMonth = new Date(2000, 11, 31);

  enumCacheSvc.get('dayOfWeek').then(function(data) {
    vm.dayOfWeek = data.map(item => ({
      ...item,
      label: translateListFilter(item.key, 'dayOfWeek', item.value),
      checked: false,
    }));
  });
  vm.isValid = () => {
    if (!$scope.form) return false;
    if ($scope.form.$invalid) return false;
    if (vm.period === '300' && !vm.dayOfWeek.some(x => x.checked)) return false;

    return true;
  };
  vm.save = function() {
    if ($scope.form.$invalid) return;
    if (vm.translation && !vm.translation.isValid(true)) return;
    if (vm.period) {
      vm.schedule.lines = [];
      var lineType =
        vm.period === '1' || vm.period === '10' || vm.period === '20' || vm.period === '30' ? 0 : 1;
      if (vm.period == 100) {
        // Yearly
        if (!vm.dayMonth) return;
        vm.schedule.lines.push({
          type: 0,
          date: `2000-${vm.dayMonth.getMonth() + 1}-${vm.dayMonth.getDate()}`,
          deviation: 0,
          planningDate: null,
        });
      } else if (vm.period === '300') {
        vm.dayOfWeek
          .filter(x => x.checked)
          .forEach(x => {
            vm.schedule.lines.push({
              type: 10,
              date: null,
              deviation: 0,
              planningDate: null,
              dayOfWeek: x.key,
              numberOfWeeks: vm.numberOfWeeks,
            });
          });
      } else if (vm.period >= 200) {
        // Based on dynamic date
        lineType = parseInt(vm.period.slice(-2)); //lineType = last 2 digits from period: 2xx
        vm.schedule.lines.push({
          type: lineType,
          date: null,
          deviation: (vm.deadlineDeviation || 0) * vm.deadlineDeviationFactor,
          planningDate: null,
        });
      } else if (vm.period >= 30) {
        // bi-monthly
        var year = '2000';
        for (var i = 1; i <= 12; i += 6) {
          vm.schedule.lines.push({
            type: lineType,
            date: `${year}-${i}-1`,
            deviation: 0,
            planningDate: null,
          });
        }
      } else if (vm.period >= 20) {
        // bi-monthly
        var year = '2000';
        for (var i = 1; i <= 12; i += 2) {
          vm.schedule.lines.push({
            type: lineType,
            date: `${year}-${i}-1`,
            deviation: 0,
            planningDate: null,
          });
        }
      } else if (vm.period >= 10) {
        // Quarterly
        var year = '2000';
        for (var i = 1; i <= 12; i += 3) {
          vm.schedule.lines.push({
            type: lineType,
            date: `${year}-${i}-1`,
            deviation: 0,
            planningDate: null,
          });
        }
      } else {
        // Monthly
        var year = '2000';
        for (var i = 1; i <= 12; i++) {
          vm.schedule.lines.push({
            type: lineType,
            date: `${year}-${i}-1`,
            deviation: 0,
            planningDate: null,
          });
        }
      }
    }
    if (!vm.schedule.planningDeviation) vm.schedule.planningDeviation = 0;
    $http.post(appUrls.tasks + '/api/taskperiodicity/' + taskTemplateId, vm.schedule).then(
      function({ data = {} }) {
        if (data && data.id && vm.translation && vm.translation.save) {
          return vm.translation.save(data.id).then(function() {
            $element.modal('hide');
            close(data, 500);
            flySvc.success();
            return false;
          });
        } else {
          $element.modal('hide');
          close(data, 500);
          flySvc.success();
          return false;
        }
      },
      function(error) {
        flySvc.error(error);
      },
    );
  };
  vm.periodChanged = function() {
    if (
      vm.period == 1 ||
      vm.period == 10 ||
      vm.period == 20 ||
      vm.period == 30 ||
      vm.period == 100
    ) {
      if (!vm.schedule.referenceYearType) vm.schedule.referenceYearType = 2;
    } else {
      vm.schedule.referenceYearType = null;
    }
  };
  vm.showValidationErrors = function() {
    vm.showValidation = true;
    if (vm.translation && vm.translation.isValid) vm.translation.isValid(true);
  };
  vm.cancel = function() {
    close(null, 500);
  };
}
